module.exports = __webpack_public_path__ + "static/media/img-02.f00059b3.jpg";